"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (x) {
    var tmr = new Date();
    tmr.setDate(tmr.getDate() + x);
    return tmr;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/nextXDay.js
// module id = 67
// module chunks = 0